<script setup>

import DataGrid from "@/components/common/other/DataGrid";
import Button from "@/components/common/input/Button";
import StaticWidget from "@/components/common/other/StaticWidget";
import MultiSearchDropDown from "@/components/common/input/MultiSearchDropDown";
import StaticTooltip from "@/components/common/other/StaticTooltip";
import StockSearchItem from "@/classes/stock/StockSearchItem";
import DateInput from "@/components/common/input/DateInput"

import {inject} from 'vue'

const stockSearch = inject('stockSearch');
const searchPurchaseOrder = inject('searchPurchaseOrder');

function handleClearAllFields() {

  stockSearch.value.stockSearchCriteria = new StockSearchItem();
}

</script>

<template class="cmp-browse-purchase-order">
  <div class="cmp-browse-purchase-order_wrapper">
    <StaticWidget title="Search Purchase Orders" height="735">
      <div class="cmp-browse-purchase-order_search-area">
        <div class="cmp-browse-purchase-order_search-area-icon">
<!--          <i class="fa-regular fa-magnifying-glass" style="color: var(&#45;&#45;aqua-blue-definition); font-size: 35px;"></i>-->
        </div>
        <div class="cmp-browse-purchase-order_search-fields">
          <TextInput
              v-model="stockSearch.searchCriteria.skuNumber"
              :label-width="80"
              :clearable="true"
              :width="240"
              :label-top="false"
              label="PO Number">
          </TextInput>
          <TextInput
              v-model="stockSearch.searchCriteria.skuName"
              :label-width="122"
              :clearable="true"
              :width="360"
              :label-top="false"
              label="Vessel">
          </TextInput>
          <TextInput
              v-model="stockSearch.searchCriteria.skuGroup"
              :label-width="100"
              :clearable="true"
              :width="320"
              :label-top="false"
              label="Job Number">
          </TextInput>
          <TextInput
              v-model="stockSearch.searchCriteria.skuComposite"
              :label-width="120"
              :clearable="true"
              :width="320"
              :label-top="false"
              label="Container Number">
          </TextInput>
        </div>
        <div class="cmp-browse-purchase-order_search-fields">
          <TextInput
              v-model="stockSearch.searchCriteria.description"
              :label-width="80"
              :clearable="true"
              :width="240"
              :label-top="false"
              label="Product Code">
          </TextInput>
          <TextInput
              v-model="stockSearch.searchCriteria.description"
              :label-width="123"
              :clearable="true"
              :width="360"
              :label-top="false"
              label="Product Description">
          </TextInput>
          <MultiSearchDropDown
              :width="320"
              :labelWidth="100"
              placeholder="Select"
              label="Origin Port"
              :label-top="false"
              :selectPrimitiveValue="true"
              :disableFilter="true">
          </MultiSearchDropDown>
          <MultiSearchDropDown
              style="margin-left: 10px"
              :width="320"
              :labelWidth="110"
              placeholder="Select"
              label="Destination Port"
              :label-top="false"
              :selectPrimitiveValue="true"
              :disableFilter="true">
          </MultiSearchDropDown>
        </div>
        <div class="cmp-browse-purchase-order_search-fields cmp-browse-purchase-order_dates">
          <DateInput
              v-model="stockSearch.searchCriteria.skuGroup"
              :clearable="true"
              :width="150"
              :label-top="true"
              label="Departure Date From">
            <el-date-picker></el-date-picker>
          </DateInput>
          <DateInput
              v-model="stockSearch.searchCriteria.skuGroup"
              :clearable="true"
              :width="150"
              :label-top="true"
              label="To">
            <el-date-picker></el-date-picker>
          </DateInput>
          <DateInput
              style="margin-left: 220px;"
              v-model="stockSearch.searchCriteria.skuGroup"
              :clearable="true"
              :width="150"
              :label-top="true"
              label="Arrival Date From">
            <el-date-picker></el-date-picker>
          </DateInput>
          <DateInput
              v-model="stockSearch.searchCriteria.skuGroup"
              :clearable="true"
              :width="150"
              :label-top="true"
              label="To">
            <el-date-picker></el-date-picker>
          </DateInput>
          <DateInput
              style="margin-left: 220px;"
              v-model="stockSearch.searchCriteria.skuGroup"
              :clearable="true"
              :width="150"
              :label-top="true"
              label="Delivery Date From">
            <el-date-picker></el-date-picker>
          </DateInput>
          <DateInput
              v-model="stockSearch.searchCriteria.skuGroup"
              :clearable="true"
              :width="150"
              :label-top="true"
              label="To">
            <el-date-picker></el-date-picker>
          </DateInput>
          <div style="margin-left: 150px;">
            <Button text="Search" type="plain"></Button>
          </div>
          <StaticTooltip :icon="false">
            <template #content>
              Clear All
            </template>
            <i class="fa-solid fa-trash-can-list" style="color:#4c4c4c; cursor: pointer; margin-top: 4px;" @click="handleClearAllFields"></i>
          </StaticTooltip>
        </div>
      </div>
      <StaticWidget title="Search Results" height="540">
        <template #right-side>
          <Button text="Refresh" type="toolbar"></Button>
        </template>
        <div class="cmp-browse-purchase-order_search-results-wrapper">
          <DataGrid
              :allowGridMenu="false"
              height="300"
              :page-size="200"
              :selectable="false"
              :row-selection="false"
              :dataSource="searchPurchaseOrder.poDummyData"
              :columns="searchPurchaseOrder.gridColumns">
            <template v-slot:view="row">
              <Button
                  data-cy="btnViewPurchaseOrder"
                  type="toolbar"
                  text="View">
              </Button>
            </template>
          </DataGrid>
        </div>
      </StaticWidget>
    </StaticWidget>
  </div>
</template>

<style lang="scss" scoped>

.cmp-browse-purchase-order {

  &_search-results-wrapper {
    margin-top: 40px;
  }

  &_search-area {
    position: relative;
    height: 150px;
    gap: 20px;
    width: 1820px;
    background-color: #f6f2f2;
    border-radius: var(--rounded-corners);
    border: 1px solid var(--border-color);
  }

  &_search-area-icon {
    position: absolute;
    top: 40px;
    left: 30px;
    height: 120px;
  }

  &_search-fields {
    display: flex;
    padding-top: 10px;
    margin-left: 20px;
    gap: 20px;
  }

  &_dates {
    margin: 30px 0 0 105px;
  }

}
</style>
